export default function ApplyClassDirective($location) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      className: '@'
    },
    link: function($scope, $element) {
      let border = $location.search()['border'] || null;
      if (border) {
        $element.addClass($scope.className);
      }
   }
  };
}
